import { Link } from "react-router-dom";

const btnGhostTeal =
  "inline-flex items-center justify-center gap-2 border border-[#159E9A]/60 text-[#159E9A] rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#159E9A] hover:text-white transition-colors";

const cards = [
  { title: "Radical Honesty", body: "Get honest about what's working, what's not, and where you've settled for \"fine.\"", color: "#FF5A4F" },
  { title: "Childlike Wonder", body: "Reconnect with the dreams, curiosities, and possibilities you've stopped making room for.", color: "#159E9A" },
  { title: "The JOYspot™", body: "Find the intersection of your values and your vision, then build your life from there.", color: "#F6A041" },
];

export function Method() {
  return (
    <section
      data-testid="method-section"
      className="relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, #FAFAF8 0%, #FFFFFF 20%, #FFFFFF 80%, #F8F7F5 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute bottom-0 left-0 w-[600px] h-[600px] opacity-[0.02]"
        style={{ background: "radial-gradient(circle, #F6A041 0%, transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-6 md:pt-8 pb-12 md:pb-14 relative z-[1]">
        <div className="max-w-3xl mb-8 reveal">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            The Blueprint4Joy<span className="align-super text-[14px] ml-1">™</span> Method
          </h2>
          <p className="mt-6 text-lg md:text-xl text-[#57534E] leading-relaxed max-w-2xl">
            See what's true. Remember what matters. Build from there.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14 mt-5">
          {cards.map((c, i) => (
            <article
              key={i}
              data-testid={`method-card-${i}`}
              className="reveal relative group transition-transform duration-300 hover:scale-[1.02]"
              style={{
                backgroundColor: `${c.color}0D`,
                border: `1px solid ${c.color}26`,
                borderRadius: "20px",
                padding: "32px 24px",
              }}
            >
              <h3 className="font-display text-3xl md:text-[34px] leading-tight mb-4 text-[#1C1917]">
                {c.title === "The JOYspot™" ? (
                  <>The JOYspot<span className="align-super text-[14px] ml-1">™</span></>
                ) : (
                  c.title
                )}
              </h3>
              <p className="text-[#57534E] leading-relaxed text-base md:text-lg">{c.body}</p>
            </article>
          ))}
        </div>
        <div className="mt-12 reveal">
          <Link
            to="/work-with-me"
            data-testid="method-cta"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[#159E9A] bg-transparent px-7 py-3 text-base font-semibold text-[#159E9A] transition-all hover:bg-[#159E9A] hover:text-white"
          >
            Explore the Method →
          </Link>
        </div>
      </div>
    </section>
  );
}
